export function parseInvoiceListQueryParams(searchParams) {
  const params = searchParams || new URLSearchParams();
  const employeeIdsRaw =
    params.get("employee_ids") || params.get("employee_id") || "";

  return {
    filterStatus: params.get("filterStatus") || null,
    listOnly: params.get("listOnly") === "true",
    sortOrder: params.get("sort") === "asc" ? "asc" : "desc",
    employeeIds: employeeIdsRaw
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean),
    startDate: params.get("start_date") || null,
    endDate: params.get("end_date") || null,
    rawStatus: params.get("rawStatus"),
    billedByOnly: params.get("billed_by_only") === "true",
  };
}

function parseEmployeeIdsFromState(state = {}) {
  if (Array.isArray(state.employeeIds)) {
    return state.employeeIds.map((id) => String(id)).filter(Boolean);
  }
  if (Array.isArray(state.employee_ids)) {
    return state.employee_ids.map((id) => String(id)).filter(Boolean);
  }
  const raw = state.employee_ids || state.employee_id || "";
  if (!raw) return [];
  return String(raw)
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean);
}

/** Merge invoice list filters from router state (preferred) and URL query params. */
export function getInvoiceListFilters(location, searchParams) {
  const fromQuery = parseInvoiceListQueryParams(searchParams);
  const state = location?.state || {};

  const employeeIds = parseEmployeeIdsFromState(state);
  const resolvedEmployeeIds = employeeIds.length
    ? employeeIds
    : fromQuery.employeeIds;

  const sortFromState =
    state.sortOrder === "asc" || state.sort === "asc"
      ? "asc"
      : state.sortOrder === "desc" || state.sort === "desc"
        ? "desc"
        : null;

  return {
    filterStatus: state.filterStatus || fromQuery.filterStatus,
    listOnly: state.listOnly === true || fromQuery.listOnly,
    sortOrder: sortFromState || fromQuery.sortOrder,
    employeeIds: resolvedEmployeeIds,
    startDate: state.start_date || state.startDate || fromQuery.startDate,
    endDate: state.end_date || state.endDate || fromQuery.endDate,
    rawStatus:
      state.rawStatus != null && state.rawStatus !== ""
        ? String(state.rawStatus)
        : fromQuery.rawStatus,
    billedByOnly: state.billedByOnly === true || fromQuery.billedByOnly,
  };
}

export function resolveInvoiceEmployeeId(invoice = {}) {
  const candidates = [
    invoice.sales,
    invoice.billed_by,
    invoice.employee_id,
  ];

  for (let i = 0; i < candidates.length; i += 1) {
    const value = candidates[i];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return String(value);
    }
  }

  return null;
}

export function invoiceMatchesEmployeeIds(invoice, employeeIds = []) {
  if (!employeeIds.length) return true;
  const invoiceEmployeeId = resolveInvoiceEmployeeId(invoice);
  return invoiceEmployeeId ? employeeIds.includes(invoiceEmployeeId) : false;
}
